// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__ri3Zx","author":"Table_author__wbhLi","authorImage":"Table_authorImage__wWrGP","unreadRow":"Table_unreadRow__1v2wX"};